import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { DefaultMapping } from '@synergy/models';

import { Attribute } from '../models/attribute';

export class AttributesApi {
    constructor(protected baseUrl: string) {}

    public cget = async (params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<Attribute>>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/attributes`, { params }),
            response => response.data
        );
    };

    public updateAttributes = async (attribute: Partial<Attribute>): Promise<ApiResult<Attribute>> => {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/attributes/${attribute.id}`, attribute),
            response => response.data
        );
    };

    public sendNewAttribute = async (attribute: Partial<Attribute>): Promise<ApiResult<Attribute>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/attributes`, attribute),
            response => response.data
        );
    };

    public deleteAttribute = async (attributeId: number): Promise<ApiResult<Attribute>> => {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/attributes/${attributeId}`),
            response => response.data
        );
    };

    public getDefaultMapping(
        params: URLSearchParams = new URLSearchParams()
    ): Promise<ApiResult<PaginatedResponse<DefaultMapping<Attribute>>>> {
        return safeRequest(
            () =>
                request.get<PaginatedResponse<DefaultMapping<Attribute>>>(`${this.baseUrl}/attributes/mapping`, {
                    params,
                }),
            response => {
                return response.data;
            }
        );
    }

    public updateDefaultMapping = async (mapping: DefaultMapping): Promise<ApiResult<DefaultMapping<Attribute>>> => {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/attributes/${mapping.id}/mapping`, {
                    defaultMapping: mapping.defaultMapping,
                }),
            response => response.data
        );
    };
}
